import { Button } from '@/components/TSX components';
import { ClickAwayListener, Fade, Popper } from '@mui/material';
import {
  CaretDown,
  CaretRight,
  MagnifyingGlass,
  Plus,
} from '@phosphor-icons/react';
import { useEffect, useRef, useState } from 'react';
import { useGetDictionariesList } from '../../settings/api/dataCatalog/getDictionariesList';
import Skeleton from '@/components/Skeleton';
import Checkbox from '@/components/Checkbox';
import Input from '@/components/Input';
import { twJoin } from 'tailwind-merge';
import { isEmpty, uniq } from 'lodash';
import ToolTip from '@/components/Tooltip';

export const NewDDList = ({
  selTables,
  setSelTables,
  updateDrillDownTableHandler,
  primarySource,
  applyBtnDisabled,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tableAnchorEl, setTableAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [selectedTables, setSelectedTables] = useState([]);
  const [dDCoords, setDDCoords] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [tooltipShow, setTooltipShow] = useState(true);

  const btnRef = useRef(null);

  const open = Boolean(anchorEl);

  const dictList = useGetDictionariesList({
    config: {
      staleTime: Infinity,
    },
  });

  useEffect(() => {
    if (
      selected?.id?.length > 0 &&
      Array.isArray(selected?.tables) &&
      selected.tables.length > 0
    ) {
      const tables = selected.tables.map((tab) => ({
        integId: selected.id,
        integName: selected.datasource,
        platform: selected.platform,
        tableId: tab.id,
        tableName: tab.name,
      }));
      setSelectedTables(tables);
    } else {
      setSelectedTables([]);
    }
  }, [selected]);

  useEffect(() => {
    if (tableAnchorEl) {
      if (btnRef.current) {
        const btnCoords = btnRef.current.getBoundingClientRect();
        const dDBtnCoords = tableAnchorEl.getBoundingClientRect();
        const temp = {
          left: dDBtnCoords.left - btnCoords.left - 260,
          top: dDBtnCoords.top - btnCoords.top,
        };
        setDDCoords(temp);
      }
    } else {
      setDDCoords(null);
      setSelected({});
    }
  }, [tableAnchorEl]);

  return (
    <div className="flex relative" ref={btnRef}>
      <Button
        onClick={(e) => {
          setAnchorEl((prev) => (prev ? null : e.target.parentElement));
        }}
        mainBtnClassName={
          open
            ? 'bg-pv-primary-primary-300 border-pv-primary-primary-300 hover:bg-pv-primary-primary-300 hover:border-pv-primary-primary-300'
            : ''
        }
        disabled={
          Array.isArray(dictList.data?.data) && dictList.data.data.length === 0
        }
      >
        <Plus />
        <span>Add Drill-down</span>
        <CaretDown
          className={`transform ${open ? `rotate-180` : ``}`}
          style={{
            transition: 'transform 0.3s ease',
          }}
        />
      </Button>
      <Popper
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-end"
        disablePortal
      >
        {({ TransitionProps }) => (
          <ClickAwayListener
            onClickAway={() => {
              setInputValue('');
              setSelectedTables([]);
              setTableAnchorEl(null);
              setSelected({});
              setAnchorEl(null);
            }}
          >
            <Fade {...TransitionProps} timeout={350}>
              <div
                className="flex flex-col w-full bg-white border border-pv-neutral-grey-100 rounded-lg"
                style={{
                  boxShadow: '0px 8px 24px 0px rgba(0, 0, 0, 0.10)',
                }}
              >
                <div
                  className="flex flex-col h-full w-[260px] max-h-[180px] overflow-y-auto"
                  onScroll={() => {
                    setTooltipShow(false);
                  }}
                >
                  {Array.isArray(dictList.data?.data) &&
                  dictList.data.data.length > 0 ? (
                    <div className="flex flex-col w-full">
                      {dictList.data.data.map((dict, ind) => {
                        let dictSelTables = 0;
                        const selTableList = structuredClone(selTables || []);
                        if (
                          Array.isArray(selTableList) &&
                          selTableList.length > 0
                        ) {
                          const temp = selTableList.filter(
                            (tab) => tab?.integId === dict?.id
                          );
                          if (temp?.length > 0) {
                            dictSelTables = temp.length;
                          }
                        }

                        return (
                          <button
                            className={`dd-btn-${dict.id} px-4 py-3 flex justify-between w-full items-center hover:bg-pv-primary-primary-50 ${selected.id === dict.id ? `bg-pv-primary-primary-50` : ``}`}
                            key={ind}
                            onClick={(e) => {
                              e.stopPropagation();
                              const target = document.querySelector(
                                `.dd-btn-${dict.id}`
                              );
                              setSelected(dict);
                              setTableAnchorEl((prev) =>
                                prev
                                  ? prev?.innerText === target.innerText
                                    ? null
                                    : target
                                  : target
                              );
                            }}
                          >
                            <span
                              className="flex gap-2"
                              style={{
                                maxWidth:
                                  dictSelTables > 0
                                    ? 'calc(100% - 56px)'
                                    : 'calc(100% - 16px)',
                              }}
                            >
                              <img
                                src={dict.logo}
                                className="w-4"
                                style={{
                                  aspectRatio: 1,
                                }}
                              />
                              <span className="flex overflow-hidden">
                                <ToolTip
                                  placement="top"
                                  title={dict.datasource}
                                  displayTooltipOnOverflow
                                  tooltipActive={tooltipShow}
                                >
                                  <span
                                    className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
                                    onMouseEnter={() => {
                                      setTooltipShow(true);
                                    }}
                                  >
                                    {dict.datasource}
                                  </span>
                                </ToolTip>
                              </span>
                            </span>
                            <span className="flex gap-2">
                              {dictSelTables > 0 && (
                                <span className="text-white text-xxs px-1.5 py-0.5 rounded-md bg-pv-primary-primary-500">
                                  {dictSelTables}
                                </span>
                              )}
                              <CaretRight
                                size={16}
                                style={{
                                  minWidth: '16px',
                                }}
                              />
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  ) : dictList.isLoading ? (
                    <div className="flex flex-col w-full">
                      {Array.from({ length: 4 }).map((_, ind) => {
                        return (
                          <div className="px-4 py-3 flex justify-between w-full">
                            <div className="flex gap-2">
                              <Skeleton
                                variant="rectangular"
                                width={20}
                                height={20}
                                className="bg-pv-neutral-grey-100"
                              />
                              <Skeleton
                                variant="rectangular"
                                width={ind % 2 === 0 ? 120 : 80}
                                height={20}
                                className="bg-pv-neutral-grey-100"
                              />
                            </div>
                            <Skeleton
                              variant="rectangular"
                              width={20}
                              height={20}
                              className="bg-pv-neutral-grey-100"
                            />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <>none</>
                  )}
                </div>
                <div className="flex border-t border-t-pv-neutral-grey-100 w-full py-1.5 px-3 justify-between">
                  <Button
                    btnSize="sm"
                    btnColor="ghost"
                    disabled={selTables?.length === 0}
                    onClick={() => {
                      setSelTables([]);
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    btnSize="sm"
                    disabled={applyBtnDisabled}
                    onClick={async () => {
                      try {
                        setInputValue('');
                        setSelectedTables([]);
                        setTableAnchorEl(null);
                        setSelected({});
                        setAnchorEl(null);
                        await updateDrillDownTableHandler();
                      } catch {}
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
      {!isEmpty(selected) && dDCoords && btnRef.current && (
        <div
          className="absolute w-[260px] bg-white rounded-lg flex flex-col"
          style={{
            top: dDCoords.top,
            left: dDCoords.left,
            boxShadow: '0px 8px 24px 0px rgba(0, 0, 0, 0.10)',
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="w-full px-3 pt-3 pb-1.5">
            <Input
              type="text"
              placeholder={`Search table`}
              showClearInput
              value={inputValue}
              className={{
                wrapper: 'h-8',
                input: {
                  wrapper: twJoin('p-2 h-full'),
                  root: 'peer ml-2 order-2 flex-1 text-xs',
                  clear: 'order-3',
                },
              }}
              rightElem={
                <MagnifyingGlass
                  size={16}
                  className="text-pv-text-secondary-text peer-focus:text-pv-neutral-grey-600 order-1"
                />
              }
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
            />
          </div>
          {inputValue?.trim?.()?.length > 0 ? (
            selectedTables.filter((tab) =>
              inputValue.trim() === ''
                ? true
                : tab.tableName.toLowerCase().includes(inputValue.toLowerCase())
            )?.length === 0 ? (
              <span className="text-xs px-3 pb-1.5">
                <span className="text-pv-text-secondary-text">{`No results found for `}</span>
                <span>"{inputValue}"</span>
              </span>
            ) : (
              <span className="text-xs px-3 pb-1.5">
                <span className="text-pv-text-secondary-text">{`Search results for `}</span>
                <span>"{inputValue}"</span>
              </span>
            )
          ) : null}
          <div
            className="flex flex-col w-full max-h-[176px] overflow-y-auto"
            onScroll={() => {
              setTooltipShow(false);
            }}
          >
            {selectedTables.filter((tab) =>
              inputValue.trim() === ''
                ? true
                : tab.tableName.toLowerCase().includes(inputValue.toLowerCase())
            )?.length > 0 ? (
              selectedTables
                .filter((tab) =>
                  inputValue.trim() === ''
                    ? true
                    : tab.tableName
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                )
                ?.map((tab, ind) => {
                  return (
                    <Checkbox
                      label={
                        <ToolTip
                          placement="top"
                          title={tab.tableName}
                          displayTooltipOnOverflow
                          tooltipActive={tooltipShow}
                        >
                          <span
                            className="overflow-hidden text-ellipsis whitespace-nowrap"
                            onMouseEnter={() => {
                              setTooltipShow(true);
                            }}
                          >
                            {tab.tableName}
                          </span>
                        </ToolTip>
                      }
                      key={ind}
                      checked={
                        selTables.findIndex((t) => t.tableId === tab.tableId) >
                        -1
                      }
                      // disabled={tab.tableName === primarySource}
                      // ${tab.tableName === primarySource ? `cursor-not-allowed` : ``}`
                      // ${tab.tableName === primarySource ? `text-t-disabled` : ``}
                      className={{
                        wrapper: `px-4 py-3 w-full flex gap-2 items-center hover:bg-pv-primary-primary-50 cursor-pointer 
                      `,
                        label: `max-w-52 overflow-hidden overflow-ellipsis whitespace-nowrap`,
                      }}
                      onChange={(e) => {
                        if (e.checked) {
                          setSelTables((prev) => {
                            let temp = [
                              ...prev,
                              {
                                integId: tab.integId,
                                integName: tab.integName,
                                platform: tab.platform,
                                tableId: tab.tableId,
                                tableName: tab.tableName,
                              },
                            ];
                            temp = temp.sort((a, b) => {
                              const tempA = `${a.integName}-${a.tableName}`;
                              const tempB = `${b.integName}-${b.tableName}`;
                              return tempA.localeCompare(tempB);
                            });
                            return temp;
                          });
                        } else {
                          setSelTables((prev) => {
                            let temp = [...prev];
                            temp = temp.filter(
                              (t) => t.tableId !== tab.tableId
                            );
                            return temp;
                          });
                        }
                      }}
                    />
                  );
                })
            ) : (
              <span className="flex px-3 py-1.5">No tables found</span>
            )}
          </div>
          {inputValue?.trim?.()?.length > 0 &&
            selectedTables.filter((tab) =>
              inputValue.trim() === ''
                ? true
                : tab.tableName.toLowerCase().includes(inputValue.toLowerCase())
            )?.length === 0 && (
              <div className="flex px-3 pb-1">
                <Button
                  btnSize="sm"
                  btnColor="secondary"
                  onClick={() => {
                    setInputValue('');
                  }}
                >
                  Clear&nbsp;search
                </Button>
              </div>
            )}
        </div>
      )}
    </div>
  );
};
